// /* eslint-disable */
// var MenuService = function(resource, $store, $route) {
//     this.resource = resource;
//     this.$store = $store;
//     this.$route = $route;
//     this.map = {};
// };

// MenuService.prototype.get = function(key) {
//     return new Promise(resolve => {
//         if (this.map[key]) {
//             resolve(this.map[key]);
//         } else {
//             this.resource
//                 .get(`/api/programMenu/list/${key}`)
//                 .then(res => {
//                     //this.map[key] = response.data;
//                     let bigMenu = res.data.filter(x => x.parentId === 13).map(x => {
//                         x.label = x.url;
//                         //x.icon = x.relateImageNm !== '/' ? x.relateImageNm : 'far fa-folder-open';
//                         x.icon = x.programExtend9 !== '' ? x.programExtend9 : 'far fa-folder-open';
//                         // x.icon = 'far fa-folder-open';
                    
//                         return x;
//                     });
                
//                     let midMenu = res.data.filter(x => x.parentId !== 13).map(x => {
//                         x.href = x.url;
//                         x.label = x.programNm;
//                         const {grantInsert, grantPrint, grantSelect, grantUpdate, grantDelete} = this.$store.state.loginInfo.authorities.filter(y => y.programId === x.programId)?.[0];
//                         x.grantInsert = grantInsert;
//                         x.grantPrint = grantPrint;
//                         x.grantSelect = grantSelect;
//                         x.grantUpdate = grantUpdate;
//                         x.grantDelete = grantDelete;
//                         return x;
//                     });
                
//                     let totalMenu = bigMenu.map(x => {
//                         x.children = midMenu.filter(y => y.parentId === x.programId);
//                         return x;
//                     });
//                     this.map[key] = totalMenu;
//                     return resolve(this.map[key]);
//                 })
//                 .catch(error => {
//                     this.map[key] = [];
//                     return resolve(this.map[key]);
//                 });
//         }
//     });
// };

// MenuService.prototype.getGrants = function(value, idx) {
//     console.log('this.$route', this.$route)
//     let url = value || this.$route.app._route.path;
//     let menuIdx = idx || this.$route.app._route.meta.menuIdx;
//     let key = this.$store.state.loginInfo.loginId;
    
//     if (this.map[key]) {
//         var _f = this.map[key].map(x => x)[menuIdx || 0]?.children.filter(x => x.url === url)[0];
//         return _f || {};
//     } else {
//         return {};
//     }
// }
// export default MenuService;
const mapUnique = (arr, prop) => {
    return [...new Map(arr.map((m) => [m[prop], m])).values()];
};
export default class MenuService {
    constructor(resource, $store, $route) {
        this.resource = resource;
        this.$store = $store;
        this.$route = $route;
        this.map = {};
    }

    get(key) {
        return new Promise(resolve => {            
            return resolve(this.$store.state.loginInfo.programList);
        });
    }

    getGrants(value) {
        let url = value || this.$route.app._route.path;
        if (this.$store.state.loginInfo.authorities) {
            var _f = mapUnique(this.$store.state.loginInfo.authorities.filter(x => x.url === url), 'url');
            return _f[0] || {};
        } else {
            return {};
        }
    }

}